// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"19b45e5b","45":"deb57c35","157":"128c0e46","359":"f9f94649","389":"82bed038","618":"c123a869","787":"32fa253d","889":"a6375b5e"}[chunkId] + ".chunk.js";
};